import $ from 'jquery';

$.fn.textWidth = function(text, font) {
  if (!$.fn.textWidth.fakeEl) {
    $.fn.textWidth.fakeEl = $('<span>')
      .hide()
      .appendTo(document.body);
  }
  $.fn.textWidth.fakeEl
    .text(text || this.val() || this.text())
    .css('font', font || this.css('font'));

  return $.fn.textWidth.fakeEl.width();
};

/**
 * Check if date is valid.
 * e.g. 30 February is not valid
 * @param {int} day day in a month
 * @param {int} month month
 * @param {int} year year
 * @return {Boolean} if date is valid returns true, if not false
 */
export function isDateValid(day, month, year) {
  var date = new Date(year, month - 1, day);

  return date.getMonth() + 1 == month;
}

export function getCookie(name) {
  var documentCookie = document.cookie,
    indexStart = documentCookie.indexOf(' ' + name + '='),
    indexEnd;

  if (indexStart == -1) {
    indexStart = documentCookie.indexOf(name + '=');
  }

  if (indexStart == -1) {
    documentCookie = null;
  } else {
    indexStart = documentCookie.indexOf('=', indexStart) + 1;
    indexEnd = documentCookie.indexOf(';', indexStart);

    if (indexEnd == -1) {
      indexEnd = documentCookie.length;
    }

    documentCookie = unescape(documentCookie.substring(indexStart, indexEnd));
  }

  return documentCookie;
}

export function setCookie(name, value, expireDays, path) {
  if (!path) {
    path = '/';
  }

  var exdate = new Date();

  if (!expireDays) {
    exdate.setTime(exdate.getTime() + 60000);
  } else {
    exdate.setDate(exdate.getDate() + expireDays);
  }

  var cookieValue =
    escape(value) +
    (expireDays == null ? '' : '; expires=' + exdate.toUTCString()) +
    '; path=' +
    path;

  document.cookie = name + '=' + cookieValue;
}

export function rot13(text) {
  return text.replace(/[a-zA-Z]/g, function(c) {
    return String.fromCharCode(
      (c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26
    );
  });
}

export function isNumber(obj) {
  return !isNaN(parseFloat(obj));
}

export function randRange(min, max) {
  return Math.random() * (max - min) + min;
}

/**
 * Method converts file size into human readable format
 * @param {Number} bytes filesize
 * @return String
 */
export function bytesToSize(bytes) {
  var sizes = ['Bytes', 'KB', 'MB'],
    i;

  if (bytes === 0) {
    return 'n/a';
  }

  i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);

  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

/**
 * Method gets filename from full path and cuts it to maxLength
 * @param {String} filename filename
 * @param {Number} [maxLength] maxLength
 * @return String
 */
export function parseFilename(filename, maxLength) {
  if (!maxLength) {
    maxLength = 15;
  }

  filename = filename.replace(/^.*[\\\/]/, '');

  if (filename.length > maxLength) {
    filename = filename.substr(0, maxLength) + ' ...';
  }

  return filename;
}

/**
 * Method add format possibility to String inserted directly to string prototype
 * as soon as method is called you could use your strings to be formatted in following way:
 *
 * Example:
 * "This is me: {0} {1}".format('Chuck', 'Norris');
 *
 * Outuput:
 * This is me: Chuck Norris
 */
export function format() {
  var args = arguments;

  return args[0].replace(/{(\d+)}/g, function(match, number) {
    number++;

    return typeof args[number] !== 'undefined' ? args[number] : match;
  });
}

/**
 * Method for generating random string with given length and based on given dictionary
 * @iLength {Integer} length of the output string. Default: 32
 * @sDictionary {String} string of symbols (dictionary), based on wich random hash will be generated.
 * @return {String} hash with selected length
 */
export function generateRandomString(iLength, sDictionary) {
  var text = '';
  var length = iLength || 32;
  var possible =
    sDictionary ||
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var i;

  for (i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/core/Utils.js
 **/